import 'whatwg-fetch';

import enableTabbing from './modules/EnableTabbing';
import lazyLoad from './modules/LazyLoad';
import scrollToTop from './modules/ScrollToTop';

enableTabbing();
lazyLoad();
scrollToTop();
